<template>
  <div class="text-start px-2">
    <div class="fs-4 my-2">مشاهده اطلاعات تیم ها</div>
    <Search @search="search" />
    <div v-if="teams" class="accordion" id="accordionTeam">
      <div v-for="(item, index) in teams" :key="index" class="accordion-item">
        <h2 class="accordion-header" :id="'headingOne_' + index">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="'#collapse_' + index"
            aria-expanded="false"
            :aria-controls="'collapse_' + index"
          >
            <span> {{ fromPage + index }}- &nbsp; </span>
            {{ item.name }}
            <span v-if="+item.is_full === 1">
              <i class="fas fa-check text-success mx-1"></i>
            </span>
            <span v-else>
              <i class="fas fa-window-close text-danger mx-1"></i>
            </span>
            <span class="small">
              {{ jmoment(item.created_at, "YYYY-MM-DD").format("jYYYY/jM/jD") }}
            </span>
          </button>
        </h2>
        <div
          :id="'collapse_' + index"
          class="accordion-collapse collapse hide"
          :aria-labelledby="'headingOne_' + index"
          data-bs-parent="#accordionTeam"
        >
          <div class="accordion-body">
            <ShowTable
              :members="item.team_member"
              :leader="item.leader"
              :teamUserId="item.id"
              @reloadList="getTeams"
            />
            <div v-if="+item.is_full !== 1" class="text-end">
              <button class="btn btn-danger" @click="deleteGrpConfirm(item.id)">
                حذف کامل گروه
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      <i class="fas fa-spinner fa-spin mt-3"></i>
    </div>
  </div>
  <div
    v-if="lastPage > 1"
    class="d-flex justify-content-center bd-highlight mb-3"
  >
    <span v-if="showPreviusSpin" class="fas fa-spinner fa-spin mt-3"></span>
    <a
      :disabled="currentPage > 1"
      :class="
        'btn btn-primary btn-sm m-1 ' + (currentPage > 1 ? '' : 'disabled')
      "
      @click="previusPage()"
    >
      قبلی
    </a>
    <select class="m-1 p-1" @change="changePage($event)">
      <option
        v-for="index in this.lastPage"
        :key="index"
        :selected="index == this.currentPage"
      >
        {{ index }}
      </option>
    </select>
    <a
      :disabled="currentPage != lastPage"
      :class="
        'btn btn-primary btn-sm m-1 ' +
        (currentPage != lastPage ? '' : 'disabled')
      "
      @click="nextPage()"
    >
      بعدی
    </a>
    <span v-if="showNextSpin" class="fas fa-spinner fa-spin mt-3"></span>
  </div>
</template>
<script>
import ArefApi from "@/libs/api.js";
import utils from "@/libs/utils";
import ShowTable from "./ShowTable";
import jmoment from "moment-jalaali";
import Search from "./Search.vue";

export default {
  created: function () {
    this.arefApi = new ArefApi(this);
    this.utils = new utils();
    this.getTeams();
  },
  components: {
    ShowTable,
    Search,
  },
  data() {
    return {
      teams: null,
      currentPage: this.$route.params.page ? this.$route.params.page : 1,
      lastPage: null,
      showPreviusSpin: false,
      showNextSpin: false,
      fromPage: 1,
      searchMobile: null,
    };
  },
  methods: {
    jmoment,
    getTeams() {
      this.teams = null;
      this.arefApi
        .getTeams(this.currentPage, this.searchMobile)
        .then((resp) => {
          this.teams = resp.data;
          this.currentPage = resp.meta.current_page;
          this.lastPage = resp.meta.last_page;
          this.fromPage = resp.meta.from;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    deleteGrpConfirm(teamUserId) {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.deleteGrp(teamUserId);
          }
        });
    },
    deleteGrp(teamUserId) {
      this.arefApi
        .deleteTeam(teamUserId)
        .then(() => {
          this.utils.showSuccess(this, "حذف با موفقیت انجام شد");
          this.getTeams();
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    search(searchMobile) {
      this.searchMobile = searchMobile;
      this.getTeams();
    },
    nextPage: async function () {
      this.showNextSpin = true;
      this.currentPage++;
      this.$router.push(`/admin/teams/${this.currentPage}`);
      await this.getTeams();
      this.showNextSpin = false;
    },
    previusPage: async function () {
      this.showNextSpin = true;
      this.currentPage--;
      this.$router.push(`/admin/teams/${this.currentPage}`);

      await this.getTeams();
      this.showNextSpin = false;
    },
    changePage: function (event) {
      this.$router.push(`/admin/teams/${event.target.value}`);
      this.currentPage = event.target.value;
      this.getTeams();
    },
  },
};
</script>